/* eslint-disable react/no-unstable-nested-components */
import {useContext, useState} from 'react'

import PropTypes from 'prop-types'

import {ATOM_ICON_SIZES} from '@s-ui/react-atom-icon'
import AtomPopover, {atomPopoverPositions, atomPopoverTriggers} from '@s-ui/react-atom-popover'
import Context from '@s-ui/react-context'
import {useMount} from '@s-ui/react-hooks'
import {useLocation} from '@s-ui/react-router'
import {useMediaQuery, useMediaQueryBreakpoints} from '@adv-mt/mt-layout-render-media-query'
import IconClose from '@adv-mt/mt-svg-icons/lib/Close'

const BASE_CLASS = 'mt-OnboardingAlert'
const popoverDelay = 3000

const OnboardingAlert = ({
  children,
  isAlertOfNewCategory,
  setIsViewedOnboarding = () => {},
  showOnboarding = false
}) => {
  const {domain, i18n} = useContext(Context)
  const config = domain.get('config')
  const {CARS_WITHOUT_LICENSE_CATEGORY1_ID} = config.get('search')
  const {ADS_LIST_PATH_PATTERNS, ADS_LIST_SUBSCRIPTION_PATH_PATTERN, ADS_LIST_SUBSCRIPTION_PATH_PATTERN_WITHOUT_SLASH} =
    config.get('page')
  const isDesktopOrWider = useMediaQuery(useMediaQueryBreakpoints.md)
  const {pathname} = useLocation()

  const allVehiclesTypesWithAlertsAvailable = {
    [ADS_LIST_SUBSCRIPTION_PATH_PATTERN_WITHOUT_SLASH]: i18n.t('NAVIGATION_MAIN_SEARCH_CARS_SUBSCRIPTION_TEXT'),
    [ADS_LIST_SUBSCRIPTION_PATH_PATTERN]: i18n.t('NAVIGATION_MAIN_SEARCH_CARS_SUBSCRIPTION_TEXT'),
    [ADS_LIST_PATH_PATTERNS[CARS_WITHOUT_LICENSE_CATEGORY1_ID]]: i18n.t('SEARCH.CARS_WITHOUT_LICENSE')
  }
  const vehicleType = allVehiclesTypesWithAlertsAvailable[pathname]

  const [isOpen, setIsOpen] = useState(false)

  const onClose = () => {
    setIsOpen(false)
    setIsViewedOnboarding()
  }

  useMount(() => {
    setTimeout(() => {
      setIsOpen(true)
    }, popoverDelay)
  })

  const isVisible = isAlertOfNewCategory && showOnboarding && isOpen

  return (
    <>
      <AtomPopover
        closeIcon={
          <span className={`${BASE_CLASS}-iconClose`}>
            <IconClose size={ATOM_ICON_SIZES.medium} />
          </span>
        }
        content={() => (
          <div className={`${BASE_CLASS}-content`}>
            <span className={`${BASE_CLASS}-contentBadge`}>
              {i18n.t('SEARCH_SAVE_ONBOARDING_LABEL_NEW').toUpperCase()}
            </span>

            <div className={`${BASE_CLASS}-contentText`}>
              {i18n.t('SEARCH_SAVE_ONBOARDING_TEXT', {
                vehicleType: vehicleType?.toLowerCase()
              })}
            </div>
          </div>
        )}
        hideArrow={false}
        isVisible={isVisible}
        onClose={onClose}
        placement={isDesktopOrWider ? atomPopoverPositions.LEFT : atomPopoverPositions.TOP}
        trigger={atomPopoverTriggers.MANUAL}
        type="dark"
      >
        <div className={`${BASE_CLASS}-wrapper`}>{children}</div>
      </AtomPopover>
    </>
  )
}

OnboardingAlert.propTypes = {
  children: PropTypes.node,
  isAlertOfNewCategory: PropTypes.bool,
  setIsViewedOnboarding: PropTypes.func,
  showOnboarding: PropTypes.bool
}
OnboardingAlert.displayName = 'OnboardingAlert'

export default OnboardingAlert
